<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <f7-list class="mb-2">
                    <f7-list-item >
                      <b-row class="d-flex">
                        <div class="mx-3">
                          <b-button
                              class="btn btnFilter"
                              @click="onRefresh()">

                            <i
                                class="fa fa-rotate-right"
                                aria-hidden="true">
                            </i>

                            <span class="sr-only">
                              {{ $t('common.rfrsh') }}
                            </span>
                          </b-button>
                        </div>
                        <b-button v-if="canAdd" variant="primary" @click="actionAdd" class="mx-2">
                          <span class="d-inline">{{ $t('common.global.add_provider') }}</span>
                        </b-button>
                      </b-row>
                    </f7-list-item>
                    <!-- Sélection des valeurs de Filtre -->
                    <f7-list-item :class="{'filter-item-section':true}">
                      <b-row class="min-w-100">
                        <!-- <b-col class="d-flex flex-row"> -->
                        <!-- Filtre network -->
                        <b-col lg="3" cols="6" class="filter-item" v-if="true">
                          <span class="filter-item-title">{{ $t('common.global.clearing') }}</span>
                          <span class="filter-item-content pt-6px">
                            <label for="network-filter" class="sr-only">
                              {{ $t('common.network') }}
                            </label>
                            <select
                                    autocomplete="off"
                                    id="network-filter"
                                    ref="selectTypeAction"
                                    @change="delayApplyFilter"
                                    v-model="network"
                                    class="z-2 position-relative cursor fs-14px-important h-100 mw-none">
                              <option value="">{{ $t('common.all') }}</option>
                              <option v-for="(networkValue, index) in listNetworks"
                                      :key="'network-list-item-' + index"
                                      :value="parseInt(index) ? index : ''">
                                {{ networkValue }}
                              </option>
                            </select>
                          <i class="fa-light fa-chevron-down float-right cursor mt--20px-important" ref="select-action-type"></i>
                          </span>
                        </b-col>
                        <!--Filtre provider -->
                        <b-col lg="3" cols="6" class="filter-item mb-3" v-if="false">
                          <span class="filter-item-title">{{ $t('common.global.provider_title') }}</span>
                          <span class="filter-item-content">
                            <label for="name-filter" class="sr-only">
                              {{ $t('common.name') }}
                            </label>
                            <input v-model="name" @input="delayApplyFilter"
                              id="name-filter"
                              type="text"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': name}">
                          </span>
                        </b-col>
                        <!-- Filtre identifiant -->
                        <b-col lg="3" cols="6" class="filter-item mb-3">
                          <span class="filter-item-title">{{ $t('common.global.bic') }}</span>
                          <span class="filter-item-content">
                            <label for="identifier-filter" class="sr-only">
                              {{ $t('common.identifier') }}
                            </label>
                            <input v-model="identifier" @input="delayApplyFilter"
                              id="identifier-filter"
                              autocomplete="off"
                              type="text"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': identifier}">
                          </span>
                        </b-col>
                        <b-col lg="3" cols="6" class="filter-item mb-3">
                        </b-col>
                        <!-- Bouton Effacer et Appliquer -->
                        <b-col lg="3" cols="12" class="d-flex flex-row-reverse mt-3">
                          <b-button class="btn" size="sm"
                            @click="applyFilters()">
                            {{ $t('filter.fltr') }}
                          </b-button>
                          <b-button class="btn mr-3" size="sm"
                            @click="emptyFilters"
                            :disabled="!hasInputFilter">
                            {{ $t('filter.clr_fltr_field') }}
                          </b-button>
                        </b-col>
                      </b-row>
                    </f7-list-item>
                  </f7-list>
        <spinner v-if="activateSpinner"></spinner>
        <b-table v-else-if="this.listItems.length > 0" responsive class="table-striped"
          :items="listItems"
          :fields="fields"
          :key="keyTableProvider"
          hover :selectable="listItems.length > 0"
          empty-text="Pas de résultat"
          @row-selected="onRowSelected">
          <template #cell(name)="data">
            <span>{{ data.value }}</span>
          </template>
          <template #cell(identifier)="data">
            <span>{{ data.value }}</span>
          </template>
          <template #cell(network)="data">
            <span>{{ data.value ? data.value.split(',').join(' - ') : '-' }}</span>
          </template>
          <template #cell(tokenio)="data">
            <span>{{ data.value ? data.value : '-' }}</span>
          </template>
          <template #cell(dateLastUpdate)="data">
            <span>{{ data.value | formatDateTime }}</span>
          </template>
        </b-table>
        <div class="d-flex justify-content-center mt-5" v-else><b>{{ $t('common.no_result')}}</b></div>
        <b-row v-if="!activateSpinner" class="mt-1">
          <b-col cols="12">
            <cm-pagination :maxResultsByPage="paginationObject.maxResults" :firstIndex="paginationObject.firstIndex" :nbResultsTotal="paginationObject.nbResultsTotal" :refreshEvent="paginationObject.refresh"></cm-pagination>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>
<script>
// import moment from 'moment'
// import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'
// import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import Pagination from "@/components/common/pagination.vue";

export default {
  name: 'ProviderList',
  components: {
    'cm-pagination': Pagination,
    // 'form-write-group-label-input':formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
  },
  data: () => {
    return {
      activateSpinner: false,
      elementSearchedProvider: '',
      paginationObject: {},
      identifier: '',
      keyTableProvider: false,
      listItems: [],
      listNetworks: {
        1: 'SRTP',
        2: 'GIRO',
        3: 'PSD2'
      },
      name: '',
      norm: '',
      network: '',
      sortBy: 'name'
    }
  },
  computed: {
    canAdd () {
      return this.$engine.rights.rightIs('rtp_member_ajouter', true) && !this.$engine.rights.getCurrentCountry().idCountry
    },
    canEdit () {
      return this.$engine.rights.rightIs('rtp_member_editer', true)
    },
    canDelete () {
      return this.$engine.rights.rightIs('rtp_member_supprimer', true) && this.$engine.user.getUserNorm() !== '3'
    },
    fields () {
      let fieldsList = [
        { key: 'identifier', label: this.$t('common.global.bic'), thClass: 'text-center', tdClass: 'text-center' },
      ]
      fieldsList.push({ key: 'network', label: this.$t('common.global.clearing'), thClass: 'text-center', tdClass: 'text-center' })
      return fieldsList
    },
    hasClearingFilter () {
      let currentRights = this.$engine.rights.getAll()
      let rightNormFound = false
      if (this.$engine.rights.rightIs('super_admin', true)) {
        return true
      }
      Object.entries(currentRights).forEach((right) => {
        if ((right[0].includes('_srtp') || right[0].includes('_hrtp') || right[0].includes('_psd2')) && right[1] === true) {
          rightNormFound = true
        }
      })
      return !rightNormFound
    },
    hasInputFilter () {
      if (
        this.name ||
        this.identifier ||
        this.network) {
        return true
      }
      return false
    },
    listTitle () {
      return this.$i18n.t('common.global.title')
    }
  },
  created () {
    if (!this.$engine.rights.rightIs('super_admin', true)) {
      // this.network = this.$engine.user.getUserNorm()
    }
    this.activateSpinner = true
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    this.paginationObject['refresh'] = 'provider-page'
    this.$bus.$off('provider-page')
    this.$bus.$on('provider-page', index => {
      this.onRefresh(index)
    })
    this.onRefresh()
  },
  methods: {
    actionAdd () {
      loadPage(this, { url: '/routing/provider/provider_form/add/-1'})
    },
    actionDetails (id) {
      loadPage(this, { url: '/routing/provider/provider_form/view/' + id })
    },
    applyFilters() {
      this.activateSpinner = true
      clearTimeout(this.timer)
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      let filterConditions = {
        name: this.name,
        identifier: this.identifier,
        idNetwork: this.network,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
      }
      this.getProviders(filterConditions)
    },
    delayApplyFilter() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.applyFilters()
      }, 1500)
    },
    emptyFilters() {
      this.name = ''
      this.identifier = ''
      this.network = ''
      this.applyFilters()
    },
    getNetworkValue (val) {
      switch (val) {
        case 'SRTP':
          return this.$t('common.norm.srtp')
        case 'HRTP':
          return this.$t('common.norm.giro')
        case 'PSD2':
          return this.$t('common.norm.psd2')
        default:
          return val
      }
    },
    getProviders (filters) {
      this.$engine.routing.member.fetch(filters)
      .then(resp => {
        let that = this
        let providersList = {}
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults //actionHistory.length
        that.paginationObject.nbResults = resp.data.Members.length
        providersList = resp.data.Members
        that.updateProviders(providersList)
        that.activateSpinner = false
      })
    },
    onRefresh(index = 1) {
      this.activateSpinner = true
      this.paginationObject['firstIndex'] = index
      let filterConditions = {
        name: this.name,
        identifier: this.identifier,
        idNetwork: this.network,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
      }
      this.getProviders(filterConditions)
    },
    onRowSelected(items) {
      this.keyTableProvider = !this.keyTableProvider
      this.actionDetails(items[0].idMember)
    },
    updateProviders(providersList) {
    this.listItems = providersList
    //this.fillNetworksList()
    this.activateSpinner = false
    }
  }
}
</script>
